import "./PaymentMessage.css";

export default function PaymentMessage({ message }) {
  if (!message?.text) return null;

  return (
    <div className={`payments-message payments-message-${message.type}`}>
      {message.text}
    </div>
  );
}
